import { Palette } from '@mui/material';
import { TypographyOptions } from '@mui/material/styles/createTypography';

import { breakpoints } from './breakpoints';

const fontFamily = ['Inter', 'Helvetica', 'Arial', 'sans-serif'].join(',');

export const typography: (palette: Palette) => TypographyOptions = palette => {
    const baseTypography = {
        fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
    };

    const h2Base = {
        ...baseTypography,
        fontWeight: 600,
        fontSize: '2.875rem',
        lineHeight: '110%',
        letterSpacing: -0.8,
        [`@media (max-width: ${breakpoints.values.sm}px )`]: {
            fontSize: '1.75rem',
            lineHeight: '130%',
            letterSpacing: 'normal',
        },
    };

    return {
        // there is some calculation going on with this setting
        // https://v4.mui.com/customization/typography/#font-size
        // we want to have 15px for pool-alpin
        fontSize: 13.125,

        // same as in theme-next
        fontFamily,
        h2: {
            ...h2Base,
        },
        h2Uppercase: {
            ...h2Base,
            textTransform: 'uppercase',
        },
        h3: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '2.25rem',
            lineHeight: '130%',
            letterSpacing: -0.5,
            [`@media (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.5rem',
                lineHeight: '130%',
                letterSpacing: 'normal',
            },
        },
        h4: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.75rem',
            lineHeight: '130%',
            letterSpacing: -0.3,
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.25rem',
                lineHeight: '130%',
                letterSpacing: 'normal',
            },
        },
        h5: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.375rem',
            lineHeight: '130%',
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1.125rem',
                lineHeight: '135%',
            },
        },
        h6: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '1.125rem',
            lineHeight: '135%',
            [`@media only screen and (max-width: ${breakpoints.values.sm}px )`]: {
                fontSize: '1rem',
                lineHeight: '145%',
            },
        },
        subtitle1: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.9375rem',
            lineHeight: '145%',
        },
        subtitle2: {
            ...baseTypography,
            fontWeight: 600,
            fontSize: '.8125rem',
            lineHeight: '150%',
        },
        body1: {
            ...baseTypography,
            fontSize: '.9375rem',
            lineHeight: '145%',
        },
        body2: {
            ...baseTypography,
            fontSize: '.8125rem',
            lineHeight: '150%',
        },
        caption: {
            ...baseTypography,
            fontSize: '.75rem',
            lineHeight: '150%',
        },
    };
};
